module.exports = __webpack_public_path__ + "img/HDKH2.9e91bc68.png";